import DocumentTooltip from './DocumentTooltip';
export { DocumentTooltip };
export default DocumentTooltip;
